module.exports = __webpack_public_path__ + "img/gzg.fd9b2dd7.png";